module.exports = __webpack_public_path__ + "media/assets/images/smart_working/personas-1-bg-eac3da8829c113cec6134f300a60f555.jpg";